<template>
  <div class="row animate fadeIn col-12 py-4 z-1 mx-0">
    <div class="w-100">

      <div class="row m-b-15" v-if="accidentCover">
        <div class="col-md-12 text-center text-bold">Accident Cover</div>
        <div class="col-md-12 text-center">
          <p>
            {{ accidentCover.description }}: ${{ accidentCover.price }} <br />
            {{ accidentCover.insuredIndividual }}
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center">
          <p><strong>Total Cost of Insurance Cover</strong></p>
        </div>
      </div>
      <div class="row m-b-15">
        <div class="col-md-12 text-center">
          <h2
            class="m-t-0-i m-b-0-i"
            style="color: #00a99d"
            v-text="'$' + totalCostOfInsurance.toFixed(2)"
          />

          <small v-if="summaryData.discount">Discount applied</small>
        </div>
      </div>

      <div class="row m-b-15" v-if="isExemptFromStampDuty">
        <div class="col-md-12 text-center">
          <p class="text-muted eligible-for-stamp-duty">
            <span class="alert alert-success">
              <!-- <span data-notify="icon" class="ti-bell"></span> -->
              <span
                >Eligible for Stamp Duty Exemption (-${{
                  (summaryData.stampDuty !== "undefined" &&
                  summaryData.stampDuty
                    ? summaryData.stampDuty
                    : 0
                  ).toFixed(2)
                }})</span
              >
            </span>
          </p>
        </div>
      </div>

      <div class="row m-b-15" v-if="cheapUnderwriter">
        <div class="col-md-12 text-center text-bold">
          <img
            v-if="cheapUnderwriter.logo"
            :src="cheapUnderwriter.logo"
            :alt="cheapUnderwriter.name"
            width="104"
            height="30"
          />
          <span v-else>
            {{ cheapUnderwriter.name }}
          </span>
        </div>
      </div>

      <cost-breakdown-summary></cost-breakdown-summary>

      <div class="row">
        <div class="col-md-12 text-center">
          Monthly Payments: {{ monthlyPayments }}
        </div>
      </div>
      <div class="row m-b-10-i" v-if="formComplete">
        <div class="col-md-12" v-if="monthlyPayments">
          <p class="category text-center m-t-10">
            Monthly payments are only available when checking out with 'Pay by
            the Month' option.
          </p>
        </div>
      </div>

      <div v-if="pendingOrderInfo" class="row justify-content-center">
        <p class="text-center mb-0">
          <button
            type="button"
            class="btn btn-link font-14 p-t-0-i"
            data-toggle="collapse"
            data-target="#user-information"
            :aria-expanded="userInformationExpanded ? 'true' : 'false'"
            aria-controls="user-information"
            @click="userInformationExpanded = !userInformationExpanded"
          >
            User information
            <i
              class="fa"
              :class="{
                'fa-caret-up': userInformationExpanded,
                'fa-caret-down': !userInformationExpanded,
              }"
            />
          </button>
        </p>
      </div>

      <div
        v-if="pendingOrderInfo"
        id="user-information"
        :class="{
          'm-b-25': true,
          collapse: true,
        }"
      >
        <div class="well text-center">
          <div
            class="row justify-content-center"
            v-for="(item, index) in pendingOrderInfo"
            :key="index"
          >
            <div
              :class="{
                'col-sm-8 ': true,
                'text-bold': item.bold,
              }"
            >
              {{ item.value }}
            </div>
          </div>
        </div>
      </div>

      <div class="row py-2">
        <div class="w-100 d-flex text-center justify-content-between">
          <a
            v-if="underwriter.product_liability_policy"
            class="product-disclosure-statement-link m-r-10"
            target="_blank"
            rel="noopener noreferrer"
            :href="underwriter.product_liability_policy"
          >
            Policy Wording
          </a>
          <a
            class="product-disclosure-statement-link"
            target="_blank"
            rel="noopener noreferrer"
            :href="dutyOfDisclosureUrl"
          >
            Duty of Disclosure
          </a>
          <a
            class="product-disclosure-statement-link"
            href="#"
            @click.prevent="toggleEndorsements"
            :style="showEndorsements ? 'color: #009245 !important' : ''"
          >
            Endorsements
          </a>
        </div>
      </div>

      <div class="row" v-if="step == 1 && existingPendingOrder">
        <div class="col-sm-12 m-b-20">
          <request-quote-popup></request-quote-popup>
        </div>
      </div>

      <!-- <div class="relative p-y-10" style="bottom: 5px; width: 100%">
        <div class="w-100 d-flex text-center justify-content-between">
          <div
            v-if="!quoteRejected && checkRefer"
            class="form-control col d-flex btn-refer align-items-center justify-content-center cursor-pointer"
            @click="openRefer()"
          >
            Refer a friend and save $10
          </div>
          <div
            v-if="formComplete"
            class="form-control col d-flex btn-complete align-items-center justify-content-center cursor-pointer"
            @click="openRefer()"
          >
            Checkout
          </div>
        </div>
      </div> -->

      
    </div>
    
  </div>
</template>

<script>
/**
 *  Import dependencies & event bus
 */
import store from "../../store";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import { EventBus } from "../../event-bus";
import Cookies from "js-cookie";
import { apiDomain } from "../../configs";
import * as appConfigs from "../../configs";
import axios from "axios";
import queryString from "query-string";
import { isEmpty, get, includes } from "lodash";
import { generateErrorMessage } from "../../helpers";
import CostBreakdownSummary from "./../CostBreakdownSummary.vue";
import RequestQuotePopup from "./../RequestQuotePopup";
import { SweetModal } from "sweet-modal-vue";

/**
 * Import local components
 */

export default {
  props: ["data", "messages", "formComplete", "windowHeight"],
  data() {
    return {
      modalEndorsement: null,
      email: "",
      referName: "",
      referError: "",
      referShow: true,
      processingEmailForm: false,
      animation: "calculating",
      userInformationExpanded: false,
      underwriters: [],
    };
  },
  store,
  components: {
    CostBreakdownSummary,
    RequestQuotePopup,
    SweetModal,
  },
  mounted() {
    this.initializeReminderToken();
    this.dataLoad();
  },
  watch: {
    underwriters(data) {
      if (
        this.fields.underwriter_id &&
        !data.some(
          (underwriter) =>
            !underwriter.disabled &&
            underwriter.id == this.fields.underwriter_id
        )
      ) {
        this.fields.underwriter_id = "";
      }
    },
    cheapUnderwriter(data) {
      if (data && !this.fields.underwriter_id) {
        this.fields.underwriter_id = data.id;
      }
    },
  },
  computed: {
    ...mapState({
      configs: (state) => state.configs,
      orderId: (state) => state.orderId, // 3026
      pendingOrder: (state) => state.pendingOrder,
      selectedOccupation: (state) => state.selectedOccupation,
      step: (state) => state.step,
      prevStep: (state) => state.prevStep,
      unavailableOccupations: (state) => state.unavailableOccupations,
      accidentCover: (state) => state.accidentCover,
      agreedToTerms: (state) => state.agreedToTerms,
      calculating: (state) => state.calculating,
      customerEmail: (state) => state.customerEmail,
      existingPendingOrder: (state) => state.existingPendingOrder,
      quoteRejected: (state) => state.quoteRejected,
      showEmailBlock: (state) => state.showEmailBlock,
      showEndorsements: (state) => state.showEndorsements,
      stateByPostcode: (state) => state.stateByPostcode,
      summaryData: (state) => state.summaryData,
      underwriter: (state) => state.underwriter,
      usingCreditCard: (state) => state.usingCreditCard,
    }),
    ...mapGetters([
      "isExemptFromStampDuty",
      "totalCostOfInsurance",
      "cheapestCostUnderwriterName",
    ]),

    canShowEndorsementDetailsModal() {
      return (
        this.modalEndorsement !== null && this.modalEndorsement.length !== 0
      );
    },
    fsgPdfUrl() {
      return appConfigs.fsgPdfUrl;
    },
    checkRefer() {
      if (this.referShow && isEmpty(this.pendingOrder.discount)) {
        return true;
      }

      return false;
    },
    cheapUnderwriter() {
      let min = null;
      for (let i = 0; i < this.underwriters.length; i++) {
        const item = this.underwriters[i];
        if (!item.summary) {
          continue;
        }
        if (!min || item.summary.totalPrice < min.summary.totalPrice) {
          min = item;
        }
      }
      return min;
    },
    dutyOfDisclosureUrl() {
      return appConfigs.dutyOfDisclosureUrl;
    },
    termsAndConditionsUrl() {
      return appConfigs.termsAndConditionsUrl;
    },
    bannerUrl() {
      return appConfigs.bannerUrl;
    },
    eFundInterestRate() {
      return appConfigs.eFundInterestRate;
    },
    adjustedTotal() {
      if (isEmpty(this.summaryData)) {
        return 0;
      }

      let total = this.summaryData.totalPrice || 0;

      if (this.accidentCover) {
        total += parseFloat(this.accidentCover.price);
      }
      return (total * this.eFundInterestRate).toFixed(2);
    },
    monthlyPayments() {
      if (
        isEmpty(this.pendingOrder) ||
        this.pendingOrder.period_of_cover != 12
      ) {
        return "Not Available";
      }
      let monthlyPayments = (this.adjustedTotal / 10).toFixed(2);
      return `$${monthlyPayments}`;
    },
    showSidebar() {
      return this.step >= 5;
    },

    showInReferral() {
      return (
        Cookies.get("convertFromReferral") != this.pendingOrder.id &&
        this.pendingOrder.in_referral
      );
    },

    showUnavailableOccupation() {
      if (
        this.step >= 3 &&
        this.prevStep >= 2 &&
        (includes(
          this.unavailableOccupations,
          this.pendingOrder.occupation_id
        ) ||
          this.pendingOrder.current_annual_revenue > 2500000 ||
          this.pendingOrder.status == "HS")
      ) {
        // Cleaning the pendingOrderId because
        // after the thank you page, user should be able to fill out the form again
        Cookies.remove("pendingOrderId");
        return true;
      }

      return false;
    },

    getFormFields() {
      var messages = this.messages;
      messages.forEach((item, index) => {
        item.id = index;
        if (item.type === "user") {
          item.question = messages[index - 1].questions ?? null;
        }
      });

      messages = messages.filter((item) => {
        return item.question !== undefined && item.question !== null;
      });
      return messages;
    },
    pendingOrderInfo() {
      if (isEmpty(this.pendingOrder)) {
        return null;
      }

      const fields = {
        name: { bold: true },
        occupation_id: {},
        business_name: {},
        phone: {},
        email: {},
      };

      const info = Object.keys(fields).reduce((out, item) => {
        if (this.pendingOrder.hasOwnProperty(item)) {
          out[item] = {
            ...fields[item],
            value: this.pendingOrder[item],
          };
        }
        return out;
      }, {});

      const occupation =
        info.occupation_id &&
        this.configs.occupations &&
        this.configs.occupations.filter(
          (item) => item.id == info.occupation_id.value
        )[0];
      if (occupation) {
        info.occupation_id.value = occupation.business_activity;
      }

      return info;
    },
  },

  methods: {
    ...mapMutations({
      toggleEndorsements: "toggleShowEndorsements",
    }),
    ...mapActions({
      scrollToTop: "scrollToTop",
      loadPendingOrder: "loadPendingOrder",
      loadUnderwriters: "loadUnderwriters",
      calculate: "calculate",
    }),

    getUnderwriters() {
      const formData = Object.keys(this.form).reduce(
        (out, item) => ({
          ...out,
          [item]: {
            ...this.fields,
            ...this.form[item],
          },
        }),
        {}
      );

      return this.loadUnderwriters(formData);
    },
    dataLoad() {
      if (!this.pendingOrder) {
        return;
      }

      this.loadPendingOrder({
        orderId: this.pendingOrder.id,
      })
        .then((fields) => {
          this.fields = fields;
          this.form = Object.keys(this.form).reduce((out, item) => {
            const formFields = Object.keys(
              item == "brooklyn" || item == "ensurance"
                ? omit(this.form[item], ["period_of_cover", "deductible"])
                : this.form[item]
            );
            out[item] = {
              ...this.form[item],
              ...pick(fields, formFields),
            };
            return out;
          }, {});

          return this.getUnderwriters().then((underwriters) => {
            this.underwriters = underwriters;
          });
        })
        .catch(() => {});
    },

    //check if reminder token exists, if it is then need to fire an ajax request to
    //check if the token is valid, then set the cookie, otherwise no further action
    //needed to be taken
    initializeReminderToken() {
      let vm = this;
      let queryStringObj = queryString.parse(location.search);
      if ("reminder_token" in queryStringObj) {
        //if any error/exception occur, do not need to do anything, so axios do not need
        //catch to handle error
        axios
          .get(appConfigs.decryptReminderTokenUrl, {
            params: queryStringObj,
          })
          .then((response) => {
            if (response.data.status == "error") {
              Cookies.remove("pendingOrderId");
              vm.$store.commit("setError", { error: response.data.message });
            } else if (response.data.status == "success") {
              Cookies.set("pendingOrderId", response.data.pending_order_id);
            }
          })
          .catch((error) => {
            Cookies.remove("pendingOrderId");
            vm.$store.commit("setError", { error: "Invalid token error" });
          });
      }
    },
    formatCurrency(value) {
      var parts = value.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      value = "$" + parts.join(".");
      return value;
    },
  
    showEndorsementDetailsPopup(endorsement) {
      this.modalEndorsement = endorsement;
    },
    resetModalEndorsement() {
      this.modalEndorsement = null;
    },
    infoMouseOver(event) {
      $(event.target).css("cursor", "pointer");
    },

    openRefer() {
      this.$refs.referModal.open();
    },

    submitRefer() {
      let data = {
        email: this.email,
        name: this.referName,
      };

      this.loading = true;
      this.$store.commit("setScreenLoader", { showScreenLoader: true });

      axios
        .post(`${apiDomain}form/refer-friend/${this.pendingOrder.id}`, data)
        .then((res) => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });

          if (res.status === 200) {
            const pendingOrder = res.data.data;
            this.$store.commit("setPendingOrder", { pendingOrder });

            const discount = parseFloat(pendingOrder.discount).toFixed(2);
            this.summaryData.totalPrice =
              this.summaryData.totalPrice - discount;
            this.summaryData.discount = parseFloat(
              pendingOrder.discount
            ).toFixed(2);
            const summaryData = this.summaryData;

            this.$store.commit("setSummaryData", { summaryData });

            this.referShow = false;
            this.$refs.referModal.close();
          }
        })
        .catch((err) => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          if (err) {
            this.referError = err;
          }
        });
    },
  },
};
</script>

<style lang="scss">
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.message_user {
  padding: 10px;
}
.text-blue {
  color: #1e98e0;
}
.btn-blue {
  background-color: #1e98e0;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  border: 1px solid #1e98e0;
}
.btn-blue:hover {
  background-color: #009245 !important;
  border: 1px solid #009245 !important;
}
.blue-line {
  background-color: #1e98e0;
  border-radius: 10px;
  height: 8px;
}
.message-box_user {
  border: 2px solid #bce4f9;
  background-color: #bce4f9;
  padding: 10px;
  color: #000;
  margin-top: 3px;
  border-radius: 15px 0px 15px 15px;
  width: fit-content;
  max-width: 60%;
  text-align: right;
  font-size: 16px;
  line-height: 26px;
}
@media screen and (max-width: 768px) {
  .message_user {
    padding: 5px !important;
    max-width: 100%;
  }
  .message-box_user {
    max-width: 100%;
  }
}

.banner-tc {
  font-size: 12px !important;
}

.eligible-for-stamp-duty {
  color: #00a99d;
  line-height: 32px;
}

.refer {
  background-color: #eeeeee;
  box-shadow: 0 20px 16px -15px rgba(0, 0, 0, 0.57);
  padding: 20px 0;
}

.sweet-modal-overlay {
  z-index: 1;
}

.btn-link:focus {
  box-shadow: none !important;
}

.slide-fade-enter-active {
  transition: all 0.25s ease;
}
.slide-fade-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(20px);
  opacity: 0;
}
.summarycard {
  background-color: #fafafa !important;
  box-shadow: none !important;
  border: 1px solid #dedede !important;
}
.summary-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.btn-refer {
  background-color: #fff;
  color: #009245;
  border: 1px solid #009245;
  &:hover {
    border: 1px solid #1e98e0;
  }
}
.btn-complete {
  background-color: #1e98e0;
  color: #fff;
  border-color: #1e98e0;
  &:hover {
    background-color: #009245;
  }
}

.sweet-modal-overlay {
  z-index: 1000 !important;
}
</style>
    